import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={50} height={50} fill="none" {...props}><path stroke="#000" strokeWidth={2} d="M31.504 15.297 16.913 25.945 31.428 36.89" /></svg>;
export { SvgArrowIcon as ReactComponent };
export default __webpack_public_path__ + "3b3ac43eba90a231f0e56e7b01429b34.svg";